import axios from "axios";
import { format } from "date-fns";

import { TIIVII_API_GET_CONTRACT_RECORD_AND_SHARE_AVAILABLE, TIIVII_GET_EVENTS_ENDPOINT } from "../utils/constants";
import { buildQueryParams, buildUrl, getOptions } from "./commonService";
import { LARGE_SELECT_LIMIT } from "../components/select/utils/select-constants";
import { apiPaginationConverter } from "../utils/api-pagination";

export const getAuthorizedRecording = (contractId, thenCallback) => {
  const config = getOptions({});
  const url = buildUrl(TIIVII_API_GET_CONTRACT_RECORD_AND_SHARE_AVAILABLE, {
    contract_id: contractId,
  });

  axios.get(url, config).then(response => {
    thenCallback(response.data);
  });
};

export const getEventsService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  let url = buildUrl(TIIVII_GET_EVENTS_ENDPOINT, {});

  const {
    page,
    perPage,
    limit,
    contractName,
    deploymentId,
    showDeletedEvents,
    startDate,
    endDate,
    eventStatus,
    eventTypeIds,
  } = variables;

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
    contract_name: !!contractName ? contractName : undefined,
    deployment_ids: !!deploymentId ? [deploymentId] : undefined,
    view_deleted: !!showDeletedEvents ? JSON.parse(showDeletedEvents) : false,
    from: startDate ? format(new Date(startDate), "t") : undefined,
    to: endDate ? format(new Date(endDate), "t") : undefined,
    event_status: !!eventStatus ? eventStatus : undefined,
    event_type_ids: !!eventTypeIds?.length ? eventTypeIds : undefined,
  });

  url = `${url}?${queryParams}`;

  axios
    .get(url, config)
    .then(response => {
      callback(response);
    })
    .catch(e => {
      errorCallback(e);
    });
};
